module.exports.name = 'humedades'
module.exports.projects = [
    {
        url: '/soluciones-tecnicas/humedades/filtraciones',
        title: 'Filtraciones',
        image: () => require('./images/filtracion.jpg'),
        html: `
            Encuentra la solución adecuada a tiempo...
            <br />
            <br />
            Aparecen cuando el agua presente al otro lado de un muro, penetra dentro del edificio a
            través de la pared. Sus problemas pueden ser muy variados, desde inundaciones, hasta
            el deterioro de revestimientos o la aparición de manchas de humedad y salitre en la
            pared. El problema más grave, es el que no se ve. El agua filtrada, degrada lentamente
            los materiales de construcción por los que pasa (ladrillos, hormigón, morteros...)
        `,
        htmlFull: () => `
            Encuentra la solución adecuada a tiempo...
            <br />
            <br />
            Aparecen cuando el agua presente al otro lado de un muro, penetra dentro del edificio a
            través de la pared. Sus problemas pueden ser muy variados, desde inundaciones, hasta
            el deterioro de revestimientos o la aparición de manchas de humedad y salitre en la
            pared. El problema más grave, es el que no se ve. El agua filtrada, degrada lentamente
            los materiales de construcción por los que pasa (ladrillos, hormigón, morteros...)
            <img src="${require('./images/filtracion.jpg')}" />
            A quien no le ha pasado, tener que correr en busca de un cubo tras ver cómo  en las
            primeras lluvias del año le entra el agua desde el techo o paredes.
            <img src="${require('./images/filtracion-2.jpg')}" />
            Lo primero siempre es tener una buena limpieza en las azoteas y muros libres de trastos
            que dificulte que el agua corra y hacia los bajantes estos  deberán siempre estar
            limpios y para evitar la acumulación de agua.
            <img src="${require('./images/filtracion-3.jpg')}" />
            Si busca una solución ya sea una simple pintura, para ese parcheo y salir del paso.
            Tenemos pinturas elásticas y fibradas...
            <img src="${require('./images/filtracion-4.jpg')}" />
            O por el contrario quieres una solución fiable duradera, disponemos de una gama de
            membranas liquidas súper adhesivas sobre casi cualquier tipo de soporte y ultra
            trabajables.
            <img src="${require('./images/filtracion-5.jpg')}" />
            A veces otra solución sencilla es renovar el rejuntado de aquella partes exteriores
            en las que haya cerámicas o piedras, disponemos de una gama en rejuntes en casi
            cualquier color tanto en base cementosas, porcelanicas y epoxi.
        `,
    },
    {
        url: '/soluciones-tecnicas/humedades/impermeabilizaciones',
        title: 'Impermeabilizaciones',
        image: () => require('./images/impermeabilizaciones-4.jpg'),
        html: `
            No Malgaste tu dinero, tenemos la solución definitiva tanto para depósitos de agua,
            piscinas, cubiertas ,cimentaciones ,fosos de ascensores, alcantarillado,
            canales de riego ,túneles y puentes.
        `,
        htmlFull: () => `
            No Malgaste tu dinero, tenemos la solución definitiva tanto para depósitos de agua,
            piscinas, cubiertas ,cimentaciones ,fosos de ascensores, alcantarillado,
            canales de riego ,túneles y puentes.
            <br />
            <br />
            <img src="${require('./images/impermeabilizaciones-1.jpg')}" />
            Morteros ultra rapaidos idoneos para la colocacion e impermeabilizacion y
            terminacion de accesorios en tanques agua potable ,piscinas ,etc.
            <img src="${require('./images/impermeabilizaciones-2.jpg')}" />
            Mortero de fraguados instantaneos para vias de agua con presion negativas,posiiva.
            <img src="${require('./images/impermeabilizaciones-3.jpg')}" />
            Renovar esa vieja piscinas nunca fue tan facil. morteros,membranas liquidas elasticas,
            mallas, etc con elevada estabilidad quimica.
            <img src="${require('./images/impermeabilizaciones-4.jpg')}" />
            La impermeabilización es un proceso que consiste en la protección de las edificaciones
            de los efectos que el agua pueda causar en ellas. Se considera un seguro de vida para
            el edificio y asegura la salud y comodidad de los que se encuentran en él...
            <img src="${require('./images/impermeabilizaciones-5.jpg')}" />
            ...Encontrar estos estados como los que mostramos conlleva una solución profesional
            con procesos de preparación especiales y los mejores productos en el mercado muchos con
            garantía de 30 años, así somos ,queremos lo mejor para nuestros clientes.
        `,
    },
    {
        url: '/soluciones-tecnicas/humedades/remonte-capilar',
        title: 'Remonte capilar',
        image: () => require('./images/remonte-capilar-2.jpg'),
        html: `
            Seguro que se han encontrado con estos tipos de problemas ,aquí tenemos su solución .
            <br />
            <br />
            Son las que aparecen en las zonas bajas de los muros, que absorben el agua del terreno
            a través de la cimentación. Las humedades de remonte capilar pueden ser permanentes
            cuando el nivel freático del terreno está muy alto, o pueden ser temporales o
            estacionales cuando están relacionadas con las condiciones meteorológicas (suelen
            aparecer en invierno y secarse en verano).
        `,
        htmlFull: () => `
            Seguro que se han encontrado con estos tipos de problemas ,aquí tenemos su solución .
            <br />
            <br />
            Son las que aparecen en las zonas bajas de los muros, que absorben el agua del terreno
            a través de la cimentación. Las humedades de remonte capilar pueden ser permanentes
            cuando el nivel freático del terreno está muy alto, o pueden ser temporales o
            estacionales cuando están relacionadas con las condiciones meteorológicas (suelen
            aparecer en invierno y secarse en verano).
            <img src="${require('./images/remonte-capilar-1.jpg')}" />
            Son las que aparecen en las zonas bajas de los muros, que absorben el agua del terreno
            a través de la cimentación...
            <img src="${require('./images/remonte-capilar-2.jpg')}" />
            ...cuando el problema continua lo mejor es sanear la zona llegando al soporte de origen,
            retirando todo el mortero antiguo y tratarla con un enfoscado deshumidificante a base de
            cal y puzolanas naturales, el cual extraerá en forma de vapor  de agua la humedad del
            soporte.
            <img src="${require('./images/remonte-capilar-3.jpg')}" />
            Resuelve definitivamente los problemas de condensación ,mohos ,etc.. Tanto para interior
            o exterior con diferentes tipos de acabado y tematización.
        `,
    },
]


// WEBPACK FOOTER //
// ./src/data/humedades.js